interface NavigatorWithUAData extends Navigator {
  userAgentData?: {
    platform?: "iOS" | "Android" | "Windows" | "macOS" | "Linux"
  }
}

export function isIOSMobile() {
  const ua = navigator.userAgent || ""
  const uaData = (navigator as NavigatorWithUAData).userAgentData

  // 1. Try modern userAgentData
  if (uaData?.platform) {
    if (uaData.platform === "iOS") {
      return true
    }
  }

  // 2. Fallback for user agent string
  return /iPhone|iPad|iPod/i.test(ua)
}
